import * as React from "react";
import { TryInStoreProvider, useAABSelectedChoices, TryInStoreSelectionModal } from "@grandvisionhq/fun-try-in-store";
import { useFeatureToggles } from "@grandvisionhq/state";
import { getDisplayName } from "@grandvisionhq/utils";
import "@grandvisionhq/fun-try-in-store/dist/index.css";
const TryInStorePage = ({ pageProps, pageComponent: PageComponent }) => {
  const queryParams = "queryParams" in pageProps ? pageProps.queryParams : void 0;
  const { createSelectedChoices, showTryInStoreModal, setShowTryInStoreModal } = useAABSelectedChoices({
    isTryInStoreFlowEnabled: queryParams?.tryInStoreFlow ? true : false
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps, slots: { createSelectedChoices } }), showTryInStoreModal && /* @__PURE__ */ React.createElement(TryInStoreSelectionModal, { onModalClose: () => setShowTryInStoreModal(false) }));
};
const withAABTryInStore = () => {
  return (PageComponent) => {
    const displayName = getDisplayName(PageComponent);
    const WithAABTryInStore = (pageProps) => {
      const { isTryInStoreEnabled } = useFeatureToggles();
      if (isTryInStoreEnabled) {
        return /* @__PURE__ */ React.createElement(TryInStoreProvider, null, /* @__PURE__ */ React.createElement(TryInStorePage, { pageProps, pageComponent: PageComponent }));
      } else {
        return /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps });
      }
    };
    if (typeof PageComponent.getInitialProps === "function") {
      WithAABTryInStore.getInitialProps = PageComponent.getInitialProps;
    }
    WithAABTryInStore.displayName = `WithAABTryInStore(${displayName})`;
    return WithAABTryInStore;
  };
};
export {
  withAABTryInStore
};
//# sourceMappingURL=hoc.js.map
